import styled from 'styled-components';
import { colors, dimensions } from '../../styles';

const buttonSize = 28;

const PaginationWrapper = styled.div`
  border-top: ${props => props.showBorderTop?'1px solid #D9D9D9':'none'};
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: end;
  justify-content: end;
  position: relative;
`;

const PaginationList = styled.ul`
  display: inline-flex;
  align-items: center;
  margin: 0;
  list-style: none;
  padding: 10px ${dimensions.coreSpacing}px;

		.disabled > span {
			border: 1px solid #d9d9d9;
		}

  .totalRecord {
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    / identical to box height /

    // display: flex;
    align-items: center;

    color: #000000;
  }

  .dropup {
    background: #FFFFFF;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    width: 100px;
    // height: 32px;
    padding: 5px 10px;
    margin-left: 10px;
    margin-right: 20px;
  }

  .dropup .dropdown-menu li a {
    padding: 6px 10px !important;
  }

  .countRecord {
    color: #000;
    font-weight: 700;
    margin-left: 5px;
    margin-bottom: 1px;
  }

  .fontNormal {
    font-weight: 400;
  }

  > li {
    display: inline;
    display: inline-flex;
    margin-right: 5px;
    border-radius: 10px;

    > a,
    > span {
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      min-width: 32px;
      height: 32px;
      // padding: 0 ${dimensions.unitSpacing}px;
      border-radius: 10px;
      // border: 1px solid #d9d9d9;
      line-height: 30px;
      color: #303030;
      text-align: center;
      text-decoration: none;
      outline: 0;
      transition: all ease 0.3s;
      font-weight: 700;
      font-size: 14px;

      i {
        margin: 0;
      }

      // &:hover {
      //   background: ${colors.borderPrimary};
      // }

      img {
        width: 8px; 
      }
    }

    &.disabled > a,
    &.disabled > span {
      background-color: #fff;
      cursor: not-allowed;
    }

    &.active > a {
      z-index: 3;
      color: #28A6DE;
      border: 1px solid #28A6DE;
    }
  }

  span {
    font-weight: 600;
  }
`;

const PerPageButton = styled.a`
  font-weight: 600;
  color: #303030;
  cursor: pointer;
  // margin-left: 12px;
  position: relative;
  // top: -2px;
  line-height: 19.1px
  

  span {
    color: #2B3C93;
    font-weight: 700;
    font-size: 14px;
    
  }

  i {
    // margin-left: 3px;
    font-size: 10px;
    color: #1C1B1F;
  }

  i::before {
    font-weight: 600;
  }
`;

const Option = styled.li`
  a {
    cursor: pointer;
  }
`;

export { PaginationWrapper, PaginationList, PerPageButton, Option };



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/reportPagination/styles.js